import React, { memo } from 'react';

import SnappySearchImage from './src/snappySearch.svg';

import * as Styles from './styles';

export const SnappySearch = memo(() => (
  <Styles.Wrapper>
    <Styles.SnappyAnimation
      src={SnappySearchImage}
      alt="Snappy Search"
    />
  </Styles.Wrapper>
));

SnappySearch.displayName = 'SnappySearch';
export default SnappySearch;
